export default __webpack_public_path__ + "static/media/whatsappColored.4607b927.svg";